import { jsx as _jsx } from "react/jsx-runtime";
export default function DotLeader() {
    const style = {
        display: "inline-block",
        flexGrow: 1,
        margin: "0 0.5rem",
        height: "0.4rem",
        borderBottom: "3px dotted gray"
    };
    return /*#__PURE__*/ _jsx("div", {
        style: style
    });
}
